import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getChapters(_obj, params) {
    const res = await axios.get(`api/lms/chapters/`, { params });
    return res.data;
  },
  async getChapter(_obj, id) {
    const res = await axios.get(`api/lms/chapters/${id}/`);
    return res.data;
  },
  async createChapter(_obj, data) {
    const res = await axios.post(`api/lms/chapters/`, data);
    return res.data;
  },
  async updateChapter(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/chapters/${id}/`, data);
    return res.data;
  },
  async deleteChapter(_obj, id) {
    const res = await axios.delete(`api/lms/chapters/${id}/`);
    return res.data;
  },
  async getChapterImageUploadPresignedUrl(_obj, data) {
    const res = await axios.post(`api/lms/chapters/upload-url/`, data);
    return res.data;
  },
  async updateChapterOrder(_obj, data) {
    const res = await axios.post(`api/lms/chapters/update-order/`, data);
    return res.data;
  },
};

export const chapters = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
